import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.LIGHT_GREY};
  @media (max-width: 970px) {
    flex-direction: column;
  }
`;

const OrderView = styled.a`
  background-color: ${COLORS.BLACK};
  color: ${COLORS.WHITE};
  padding: 18px 28px;
  font-size: 22px;
  border-radius: 8px;
  margin: 20px 5px;
  display: flex;
  align-items: center;
  cursor: pointer;
  @media (max-width: 970px) {
    margin-bottom: 15px;
    padding: 12px 16px;
    font-size: 18px;
  }
`;

export { Container, OrderView };
